<!--
    描述：项目新增页面
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="w-page-main add-main">
		<div class="w-page-header">
			<div class="left-header overflow-hidden">
				选择方式：
				<el-radio-group v-model="addway"
								size="small">
					<el-radio-button :label="1">新建项目</el-radio-button>
					<el-radio-button :label="2">批量导入</el-radio-button>
				</el-radio-group>
			</div>
		</div>

		<div class="w-page-container"
			 v-if="addway=='1'">
			<!-- 上方选择 -->
			<div class="top-radio">
				<el-radio-group v-model="addmethod">
					<el-radio :label="1">新建项目</el-radio>
					<!-- <el-radio :label="2">选择历史项目</el-radio> -->
				</el-radio-group>
			</div>

			<!-- 下方内容 -->
			<div class="add-content">
				<addnew ref="addnew"
						v-if="addmethod=='1'"></addnew>
				<addold ref="addold"
						v-if="addmethod=='2'"></addold>
			</div>

			<!-- 下方保存按钮 -->
			<div class="add-footer">
				<el-button type="primary"
					   size="small"
					   @click="doConfirm">确 定</el-button>
			</div>
			
		</div>
	</div>
</template>

<script>
import addnew from './components/addnew'
import addold from './components/addold'
export default {
	name: 'Project-add',
	components: { addnew, addold },
	props: {},
	data() {
		return {
			addway: 1,
			addmethod: 1
		}
	},
	methods: {
		doConfirm() {
			this.btnLoading = true
			if (this.addmethod === 1) {
				this.$refs.addnew.doConfirm()
			} else {
				this.$refs.addold.doConfirm()
			}
		}
	}
}
</script>

<style scoped lang="less">
.add-main {
	.left-header {
		font-weight: 700;
		margin-right: auto;
	}

	.top-radio {
		height: 30px;
	}

	.add-content {
		height: calc(~"100% - 80px");
    	overflow-y: auto;
	}

	.add-footer {
		height: 50px;
		line-height: 50px;
		text-align: center;
	}
}
</style>
